//@flow
import React from 'react';

type Props = {
  qty?:number,
};

export default function CartItemQty(props:Props) {
  return (
    <div className="cart-item-qty">
      <span className="item-qty">{props.qty}</span>
      <span className="select-arrow"></span>
    </div>
  );
}
